import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IFreeInputBehavior } from "../../../../documaker/domain/format/objects";

export interface IFreeInputBehaviorPropertyEditable {
  freeInputBehavior(): IPropertyEditable<IFreeInputBehavior>;
}

export function instanceOfIFreeInputBehaviorPropertyEditable(instance: any): instance is IFreeInputBehaviorPropertyEditable {
  return instance
      && instance.freeInputBehavior
      && instanceOfIPropertyEditable<IFreeInputBehavior>(instance.freeInputBehavior());
}
